import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { createAppReducer } from './createAppReducer';
import { createAppMiddlewares } from './createAppMiddlewares';

/**
 * @returns {import('ha/myredux/types').MyReduxStore}
 */
export function createAppStore({
  config,
  errorTracker,
  initialState,
  services,
  routerRef,
}) {
  const middlewares = createAppMiddlewares({
    debug: config.debug,
    errorTracker,
    services,
    routerRef,
  });
  const enhancer = applyMiddleware(...middlewares);
  const store = createStore(
    createAppReducer(),
    initialState,
    process.browser ? composeWithDevTools(enhancer) : enhancer,
  );

  store.asyncReducers = {};
  store.injectAsyncReducer = (name, asyncReducer) => {
    if (store.asyncReducers[name]) {
      return;
    }

    store.asyncReducers[name] = asyncReducer; // eslint-disable-line no-param-reassign
    store.replaceReducer(createAppReducer(store.asyncReducers));
  };

  return store;
}
